<template>
  <div class="avoid-break-inside flex break-before-page flex-col gap-4 pt-10">
    <div class="text-body-medium text-on-surface-variant flex flex-row">
      <span>{{ organizationName }}</span> ・
      <span>
        Dialog zwischen {{ memberFullName(coachee) }} und {{ memberFullName(coach) }}
      </span>
    </div>
    <div class="border-outline-variant rounded-small flex h-52 flex-col border p-2">
      <div class="flex flex-row items-center">
        <span class="text-title-small text-on-surface grow">Bemerkungen</span>
        <BaseIcon class="text-on-surface">stylus_note</BaseIcon>
      </div>
    </div>
    <div class="border-outline-variant rounded-small flex flex-col border p-2">
      <div class="flex flex-row items-center">
        <span class="text-title-small text-on-surface grow">{{ $t('common.coachees') }}</span>
        <BaseIcon class="text-on-surface">stylus_note</BaseIcon>
      </div>

      <div class="grid grid-cols-3 gap-4">
        <div class="flex flex-col">
          <div class="border-outline mb-1 h-20 w-full border-b"></div>
          <span class="text-body-medium text-on-surface">Ort</span>
        </div>
        <div class="flex flex-col">
          <div class="border-outline mb-1 h-20 w-full border-b"></div>
          <span class="text-body-medium text-on-surface">Datum</span>
        </div>
        <div class="flex flex-col">
          <div class="border-outline mb-1 h-20 w-full border-b"></div>
          <span class="text-body-medium text-on-surface"
            >{{ memberFullName(coachee) }}</span
          >
        </div>
      </div>
    </div>
    <div class="border-outline-variant rounded-small flex flex-col border p-2">
      <div class="flex flex-row items-center">
        <span class="text-title-small text-on-surface grow">{{ $t('common.coach') }}</span>
        <BaseIcon class="text-on-surface">stylus_note</BaseIcon>
      </div>
      <div class="grid grid-cols-3 gap-4">
        <div class="flex flex-col">
          <div class="border-outline mb-1 h-20 w-full border-b"></div>
          <span class="text-body-medium text-on-surface">Ort</span>
        </div>
        <div class="flex flex-col">
          <div class="border-outline mb-1 h-20 w-full border-b"></div>
          <span class="text-body-medium text-on-surface">Datum</span>
        </div>
        <div class="flex flex-col">
          <div class="border-outline mb-1 h-20 w-full border-b"></div>
          <span class="text-body-medium text-on-surface"
            >{{ memberFullName(coach) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import type { Member } from '@/core/models/member/member'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import { memberFullName } from '@/core/models/member/member-name'

  interface Props {
    coachee: MemberOrUser
    coach: Member
    organizationName: string
  }

  defineProps<Props>()
</script>
